import { useState, useEffect } from 'react' //
import { message } from 'core/components/ui'
import RequesterStock, { requesterStockMethods } from 'core/requesters/RequesterStock'
import Hydrator, { hydratorMethods } from 'core/hydrator'

const useGetStock = props => {
  const { redirectMessage } = props
  const [loadingVehicles, setLoadingVehicles] = useState(false)
  const [vehicles, setVehicles] = useState(null)

  const [loadingFiltersDatas, setLoadingFiltersDatas] = useState(false)
  const [filtersDatas, setFiltersDatas] = useState(null)
  const [filters, setFilters] = useState(null)
  const [filtersList, setFiltersList] = useState({ limit: 5, offset: 0, total: true })

  const getVehicles = params => {
    setLoadingVehicles(true)

    const finalParams = { ...filtersList, ...filters, ...params }

    RequesterStock.get(requesterStockMethods.GET_CARS, finalParams, redirectMessage)
      .then(datas => {
        const { cars } = datas

        const list = cars.map(item => {
          const vehicle = {
            ...item,
            colors: {
              exterior: item.externalColor,
              interior: null
            }
          }
          return Hydrator.hydrate(hydratorMethods.HYDRATE_VEHICLE, vehicle)
        })

        setVehicles(list)
      })
      .catch(e => message.error(e))
      .finally(() => {
        setLoadingVehicles(false)
      })
  }

  const getFiltersDatas = prevDatas => {
    getVehicles()
    setLoadingFiltersDatas(true)

    const finalParams = { ...filters }
    RequesterStock.get(requesterStockMethods.GET_INIT_FILTERS, finalParams, redirectMessage)
      .then(datas => {
        setFiltersDatas({ ...prevDatas, ...datas })
      })
      .catch(e => message.error(e))
      .finally(() => {
        setLoadingFiltersDatas(false)
      })
  }

  useEffect(() => {
    if (filtersList || filters) getVehicles()
  }, [filtersList, filters])
  return {
    loadingVehicles,
    getVehicles,
    vehicles,
    setFiltersList,
    setFilters,
    filters,
    loadingFiltersDatas,
    getFiltersDatas,
    setFiltersDatas,
    filtersDatas
  }
}

export default useGetStock
